import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface CategoryScore {
  total: number;
  count: number;
}

interface CategoryProgressProps {
  categoryScores: Record<string, CategoryScore>;
}

export const CategoryProgress = ({ categoryScores }: CategoryProgressProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Progress by Category</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {Object.entries(categoryScores).map(([category, { total, count }]) => {
            const average = Math.round(total / count);
            
            return (
              <div key={category} className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>{category}</span>
                  <span className="font-medium">{average}%</span>
                </div>
                <Progress value={average} className="h-2" />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};